import React from 'react';
import CourseSchedulerComponent from '../../modules/course/CourseScheduler';

const CourseSchedulerPage = () => {
  return (
    <div className="container-fluid">
      <CourseSchedulerComponent />
    </div>
  );
};

export default CourseSchedulerPage;
